import t from "../../components/navigationbar/NavigationBar.js";
import i from "../../components/defaultComponent/DefaultComponent.js";
import e from "../../components/siteNavigation/SiteNavigation.js";
import m from "../../components/footer/Footer.js";
import n from "../../components/ourJourneyTimelines/OurJourneyTimelines.js";
import a from "../../components/HeroComponent/HeroComponent.js";
import p from "../../components/siteLogo/SiteLogo.js";
import s from "../../components/FaqGroups/FaqGroups.js";
import _ from "../../components/NewsTimelines/NewsTimelines.js";
import c from "../../components/AboutAmway/RichTextComponent/RichTextComponent.js";
import f from "../../components/AboutAmway/QuickLinkDesignOne/QuickLinkDesignOne.js";
import d from "../../components/AboutAmway/QuickLinkDesignTwo/QuickLinkDesignTwo.js";
import l from "../../components/heroBanner/HeroBanner.js";
import u from "../../components/AwardsAndAccoladesTimelines/AwardsAndAccoladesTimelines.js";
import C from "../../components/AboutAmwayBrands/AboutAmwayBrands.js";
import g from "../../components/AmwayBusinessLinks/AmwayBusinessLinks.js";
import y from "../../components/DownloadLink/DownloadLink.js";
import w from "../../components/AmwayHighlights/AmwayHighlights.js";
import h from "../../components/StepsToBusinessOwner/StepsToBusinessOwner.js";
import A from "../../components/BannerRichText/BannerRichText.js";
import T from "../../components/OurPromises/OurPromises.js";
import b from "../../components/MeetOurPeople/MeetOurPeople.js";
import k from "../../components/ShopByCategory/ShopByCategory.js";
import v from "../../components/Notification/Notification.js";
import B from "../../components/ShopByContainer/ShopByContainer.js";
import x from "../../components/FeaturedCardContainer/FeaturedCardContainer.js";
import O from "../../components/VideoBanner/VideoBanner.js";
import F from "../../components/FeaturedArticleCarousalComponent/FeaturedArticleCarousalComponent.js";
import S from "../../components/MyAccountContainer/MyAccountContainer.js";
import { F as q } from "../../FeaturedCard-927918cf.mjs";
import L from "../../components/ContentCard/ContentCard.js";
import r from "../../components/ContentCardCarousel/ContentCardCarousel.js";
import N from "../../components/ArticleCard/ArticleCard.js";
import D from "../../components/ResourceCard/ResourceCard.js";
import H from "../../components/PromotionCard/PromotionCard.js";
import P from "../../components/ArticleOverview/ArticleOverview.js";
import R from "../../components/Faq/Faq.js";
import G from "../../components/VideoSection/VideoSection.js";
import V from "../../components/HighlightsC/HighlightsC.js";
import I from "../../components/StandardBannerNoCTA/StandardBannerNoCTA.js";
import M from "../../components/ImageWithOptionalCTA/ImageWithOptionalCTA.js";
import Q from "../../components/AudioPlayer/AudioPlayer.js";
import { T as j } from "../../TextOnly-1d491347.mjs";
import J from "../../components/ImageAndTextContainer/ImageAndTextContainer.js";
import W from "../../components/GridViewImageGallery/GridViewImageGallery.js";
import z from "../../components/AccordionComponent/AccordionComponent.js";
import E from "../../components/TableComponent/TableComponent.js";
import { ComponentType as o } from "./types/propTypes.js";
const jo = {
  [o.table_component]: E,
  [o.accordion_component]: z,
  [o.image_and_text]: J,
  [o.grid_view_image_gallery]: W,
  [o.audio_player]: Q,
  [o.text_only]: j,
  [o.image_with_optional_cta]: M,
  [o.mega_menu]: t,
  [o.top_navigation]: e,
  [o.default]: i,
  [o.footer]: m,
  [o.journey_timelines]: n,
  [o.hero_component]: a,
  [o.site_logo]: p,
  [o.faq_groups]: s,
  [o.faq]: R,
  [o.news_timelines]: _,
  [o.rich_text_component]: c,
  [o.quick_links_design_one]: f,
  [o.quick_links_design_two]: d,
  [o.hero_banner]: l,
  [o.awards_timelines]: u,
  [o.about_amway_brands]: C,
  [o.amway_highlights]: w,
  [o.steps_to_business_owner]: h,
  [o.download_links]: y,
  [o.amway_business_links]: g,
  [o.banner_rich_text_component]: A,
  [o.amway_promises]: T,
  [o.meet_our_scientists]: b,
  [o.featured_cards]: k,
  [o.notification]: v,
  [o.shop_by_container]: B,
  [o.featured_card_container]: x,
  [o.video_banner]: O,
  [o.featured_articles_carousal]: F,
  [o.my_account_container]: S,
  [o.featured_display_card]: q,
  [o.content_card]: L,
  [o.content_card_carousal]: r,
  [o.article_card]: N,
  [o.promotion_card]: H,
  [o.resource_card]: D,
  [o.article_carousel]: r,
  [o.promotion_carousel]: r,
  [o.resource_carousel]: r,
  [o.article_overview]: P,
  [o.video_section]: G,
  [o.highlights_c]: V,
  [o.standard_banner_no_cta]: I
};
export {
  jo as default
};
//# sourceMappingURL=componentRegistry.js.map
